import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ComparableResultsRow, BackButton, SimpleFlexbox } from 'ctm-components';
import { selectedProductSelector, resultsConfigSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';

import styles from './more_info.css';

/**
 * More Info Component
 * @extends BaseComponentInterface
 * @desc Used to render the more info page for a product
 * @returns {Node} a More Info Component
 */
class _MoreInfo extends Component {

    constructor(props) {
        super(props);
        this.annualPrefix = '_A';
        this.monthlyPrefix = '_M';
        this.footerBackBtn = {
            visualProps: { variant: 'full_width', textAlign: 'center' },
            elementProps: { tagName: 'a', href: 'javascript:;' },
            contentProps: { iconPosition: 'before', icon: 'ctm_angle_left', innerHTML: '<strong>Back</strong> to all products' }
        };
        this.mobileBackBtn = {
            className: styles.mobile_close_icon,
            visualProps: {
                UIComponent: 'btn_primary_small_rounded',
                variant: ''
            },
            elementProps: { tagName: 'a' },
            contentProps: { icon: 'ctm_cross' }
        };
    }

    /**
     * This function switches the productId based on frequency and updates the store
     * @param {String} productId The product id
     * @param {String} frequency Pricing frequency
     */
    updateProduct = (productId, frequency) => {
        const { dispatch } = this.props;
        let newProductId = productId;
        newProductId = frequency === 'monthly' && productId.includes(this.annualPrefix) ? newProductId.replace(this.annualPrefix, this.monthlyPrefix) : newProductId;
        newProductId = frequency === 'annual' && productId.includes(this.monthlyPrefix) ? newProductId.replace(this.monthlyPrefix, this.annualPrefix) : newProductId;
        if (productId !== newProductId) {
            dispatch({
                type: 'SET_VALUE',
                identifier: 'data.selectedProductId',
                value: newProductId,
                stateKey: 'vertical.quote'
            });
        }
    };

    /**
     * Lifecycle method to update state for new props. If the product is frequency specific this will switch the selected product based on the frequency.
     * @param {Object} nextProps - The incoming set of props
     */
    componentWillReceiveProps = (nextProps) => {
        const { frequency, product } = this.props;
        if (nextProps.frequency !== frequency) {
            const productId = product.getIn(['productMeta', 'id']);
            if (productId.includes(this.annualPrefix) || productId.includes(this.monthlyPrefix)) {
                this.updateProduct(productId, nextProps.frequency);
            }
        }
    };

    render = () => {
        const { product, layout } = this.props;
        const { breakpoint } = pageContext.getProps().pageState;
        return (
            <SimpleFlexbox position="relative">
                <BackButton {...this.mobileBackBtn} />
                <ComparableResultsRow product={product} layout={layout} breakpoint={breakpoint} />
                <BackButton {...this.footerBackBtn} />
            </SimpleFlexbox>

        );
    };

}

_MoreInfo.propTypes = {
    product: PropTypes.object.isRequired,
    layout: PropTypes.array.isRequired,
    frequency: PropTypes.string,
    dispatch: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        product: selectedProductSelector(state),
        frequency: resultsConfigSelector(state).getIn(['filters', 'frequency'])
    };
};

const MoreInfo = connect(mapStateToProps)(_MoreInfo);
export { _MoreInfo, MoreInfo };
